import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Typography, Link, Alert, Box } from "@mui/material";
import { useAuth } from "@/contexts/AuthContext";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { SYS_CONFIG } from "@/utils/constants";
import {
  LoginContainer,
  LoginPaper,
  Logo,
  Form,
  ActionContainer,
} from "./styles";

const Login = () => {
  const navigate = useNavigate();
  const { login, loading } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(""); // 清除錯誤訊息
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(formData.username, formData.password);
      navigate("/users");
    } catch (err) {
      //setError(err.response?.data?.detail || "登入失敗，請檢查帳號密碼");
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <LoginContainer>
      <LoginPaper elevation={3}>
        <Logo src="/logo.png" alt="Logo" />
        <Typography component="h1" variant="h5">
          登入系統
        </Typography>

        <Form onSubmit={handleSubmit}>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="帳號"
            name="username"
            autoComplete="username"
            autoFocus
            value={formData.username}
            onChange={handleChange}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="密碼"
            type="password"
            id="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleChange}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}
          >
            登入
          </Button>
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Typography variant="caption" color="text.secondary">
              {SYS_CONFIG.VERSION}
            </Typography>
          </Box>
        </Form>
      </LoginPaper>
    </LoginContainer>
  );
};

export default Login;
